import React from 'react';

const If = props => {
  const { condition, children } = props;
  if (condition) {
    return children;
  }
  return <></>;
};

export default If;
